<body [ngClass]="{ 'primary': layout.mode == 'primary', 'split': layout.mode == 'split' || layout.mode == 'soft',  'soft': layout.mode == 'soft',  'safe': layout.mode == 'safe',  'danger': layout.mode == 'danger', 'web-primary': layout.webMode == 'primary', 'web-split': layout.webMode == 'split',  'web-safe': layout.webMode == 'safe',  'web-danger': layout.webMode == 'danger' }">
  <app-network-status-banner></app-network-status-banner>
  @if(showChangeBookingBanner) {
  <mat-toolbar class="change-booking-banner">
    <span>{{ 'Intellitrailer.Booking.ChangeBooking.Banner.Title' | translate : 'Change booking' }}</span>
    <span style="flex: 1 1 auto;"></span>
    <a mat-button href="" style="color: white !important; text-decoration: underline;" (click)="cancelChangeBooking(); $event.preventDefault()">
      {{ 'Intellitrailer.Booking.BeginBooking.Cancel' | translate : 'Cancel' }}
    </a>
  </mat-toolbar>
  }
  @if(appSettings.appType == 'app' && appSettings.contextId.toUpperCase() == '64A0F0E3-AF2A-499B-BF1F-208900D08577') {
  @if(!isStarting) {
  <ng-container>
    <app-Use4Free></app-Use4Free>
  </ng-container>
  }
  }
  @else {
  <ng-container *ngIf="!isStarting">

    <div class="view-title" *ngIf="layout.header.visible" [ngClass]="{ 'overlay': layout.header.overlay }">
      @if(layout.header.showBack)
      {
      <mat-icon class="back" (click)="back()">west</mat-icon>
      }
      @else{
      <mat-icon class="back"></mat-icon>
      }
      <h2>{{ layout.title }}</h2>
      <mat-icon class="menu" (click)="showMenu()" *ngIf="layout.header.showMenu">menu</mat-icon>
    </div>
    <div class="content container-fluid">
      <main [class.app]="isApp" [class.frameless]="appSettings.appType == 'frameless-web'" [class.web]="appSettings.appType == 'web'">
        <router-outlet #outlet="outlet"></router-outlet>
      </main>
    </div>
    <div *ngIf="menuToggle" class="menu-container">
      <app-menu [toggle]="menuComponentToggle" (toggleMenu)="showMenu()"></app-menu>
      <bsg-outside-menu (click)="showMenu()"></bsg-outside-menu>
    </div>
    <div id="app-loader" *ngIf="false">
      <app-on-load [load]="loaded" (loaded)="displayCancelLoad()"></app-on-load>
      <div class="loader-content">
        <mat-spinner mode="indeterminate"></mat-spinner>
        <span class="loaderMessage"> {{ UI.loading.messageTranslationKey | translate : UI.loading.translationDefault }}</span>
        <div>
          <button style="margin: 5px; border-radius: 100px;height: 36px; width: 36px; padding: 5px;" matTooltip="{{ 'Intellitrailer.Booking.BeginBooking.Cancel' | translate : 'Cancel' }}" type="button" class="btn btn-default" (click)="UI.cancel();cancelLoad()" *ngIf="false && showCancelLoad">
            <mat-icon>cancel</mat-icon>
          </button>

          <button type="button" mat-raised-button (click)="UI.cancel();cancelLoad()" *ngIf="showCancelLoad" style="min-height: 40px; margin-top: 10px; margin-bottom: 10px;">
            {{ 'Intellitrailer.Booking.BeginBooking.Cancel' | translate : 'Cancel' }}
          </button>

        </div>
      </div>
    </div>

    @if(appSettings.appType == 'app') {

    <nav class="bottom-nav-app">

      <div class="tab" role="button" tabindex="0" (click)="navigate('Start')">
        <mat-icon class="nav-icon">home</mat-icon>
        <span class="label">{{ 'Intellitrailer.Booking.AppComponent.mnuHome' | translate : 'Home' }}</span>
      </div>

      <div class="tab" role="button" tabindex="0" (click)="navigateToMap()">
        <mat-icon class="nav-icon">map</mat-icon>
        <span class="label">{{ 'Intellitrailer.Booking.AppComponent.mnuMap' | translate : 'Map' }}</span>
      </div>

      <div class="tab" role="button" tabindex="0" (click)="this.appSettings.userId ? navigate('MyPage.Overview') : navigate('Booking.SignIn')" (keyup.enter)="this.appSettings.userId ? navigate('MyPage.Overview') : navigate('MyPage.SignIn')">
        <mat-icon class="nav-icon">rv_hookup</mat-icon>
        <span class="label">{{ 'Intellitrailer.Booking.AppComponent.mnuBookings' | translate : 'Bookings' }}</span>
      </div>

      @if(appSettings.appType == 'app' && (this.appSettings.contextId.toLowerCase() == 'kanleiesunmanned_api' || this.appSettings.contextId.toLowerCase() == '24rentalunmanned_api' || this.appSettings.contextId.toLowerCase() == '43d09b7e-079a-4b29-83cb-abbc928a7358')){
      <div class="tab chat-tab" [class.with-invite]="!userClosedChatInfo && showChatInvite" (click)="chatbot.openChat(); dismissChatInvite()">
        <mat-icon class="nav-icon">chat</mat-icon>
        <span class="label">{{ 'Intellitrailer.Booking.AppComponent.mnuChat' | translate : 'Chat' }}</span>
      </div>

      @if(!userClosedChatInfo && showChatInvite) {
      <div class="invite-card">
        <div class="row text-center gx-0">
          <p><strong>{{ 'Intellitrailer.AppComponent.Chat.Invite.Title' | translate : 'Need help?' }}</strong></p>
          <!--<small>{{ 'Intellitrailer.AppComponent.Chat.Invite.Description' | translate : 'You can chat with us any time using our chat option.' }}</small>-->
          <small>
            {{'Intellitrailer.AppComponent.Chat.Invite.Description2' | translate :  'If you have any questions or need assistance, we’re here for you. Our digital assistant Vendela is available at anytime to help you. Just click the chat button!' }}
          </small>
        </div>
        <!-- <button class="invite-close" (click)="dismissChatInvite()">✕</button>-->
        <button class="invite-close" mat-icon-button (click)="$event.stopPropagation(); dismissChatInvite()"><mat-icon>close</mat-icon></button>
      </div>
      }
      }
    </nav>
    }
  </ng-container>
  }
</body>
 <app-chatbot #chatbot></app-chatbot>
<ng-container *ngIf="showTestMessage">
  <div *ngIf="settings.Environment == 1" style="position: absolute; background: rgba(255, 0, 0, 0.75); height: 30px; bottom: 0; inset-inline-start: 0; width: 100vw; color: white; font-size: 15pt; z-index: 1000000000; text-align: center; " (click)="hideTestMessage()">-- Development --</div>
  <div *ngIf="settings.Environment == 2" style="position: absolute; background: rgba(255, 0, 0, 0.75); height: 30px; bottom: 0; inset-inline-start: 0; width: 100vw; color: white; font-size: 15pt; z-index: 1000000000; text-align: center; " (click)="hideTestMessage()">-- Staging --</div>
  <div *ngIf="settings.Environment == 3" style="position: absolute; background: rgba(255, 0, 0, 0.75); height: 30px; bottom: 0; inset-inline-start: 0; width: 100vw; color: white; font-size: 15pt; z-index: 1000000000; text-align: center; " (click)="hideTestMessage()">-- Test --</div>
</ng-container>
<app-idle-timer></app-idle-timer>
